module.exports = "/images/carla.webp?4e37f416106e8a981af03ddfb69115d1";